import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeleteCustomerStory() {
    const api = useApi();
    const toaster = useToaster();
    const queryClient = useQueryClient();

    return useMutation<void, Error, number>({
        mutationKey: ["expert", "customer-stories", "delete"],
        mutationFn: async (storyId) => {
            await api.expert.deleteCustomerStory({ params: { story: storyId } });
        },
        onSuccess: async (_, storyId) => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["expert", "customer-stories"] }),
                queryClient.invalidateQueries({ queryKey: ["expert", "customerStories"] }),
                queryClient.removeQueries({ queryKey: ["expert", "customer-stories", storyId] }),
            ]);
            toaster.create({ title: "Case study deleted", type: "success" });
        },
        onError: (error) => {
            toaster.create({ title: error.message || "Failed to delete case study", type: "error" });
        },
    });
}

export default useDeleteCustomerStory;
